import 'style-loader!css-loader!./Style/bootstrap.css';
import 'style-loader!css-loader!./Style/bootstrap-extend.css';
import 'style-loader!css-loader!./Style/font-awesome/font-awesome.css';
import 'style-loader!css-loader!./Style/material-design/material-design.css';
import 'style-loader!css-loader!./Style/Fonts/Fonts.css';

import 'style-loader!css-loader!./Style/bootstrap-override.css';
import 'style-loader!css-loader!./Style/app.css';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./~/tslint-loader??ref--3!./app/style.ts